const { DateTime } = require('luxon');

export const formatDate = (dateVal) => {
    return dateVal ? DateTime.fromISO(dateVal).toFormat('dd-MM-yyyy') : '';
};


export const formatTableDate = (dateVal) => {
    return dateVal ? DateTime.fromISO(dateVal).setLocale('en-GB').toFormat('dd-MM-yyyy') : '';
};

export const formatRequestDate = (dateVal) => {
    if (dateVal) {
        var date = new Date(dateVal);
        let year = date.getFullYear();
        let month = ('0' + (date.getMonth() + 1)).slice(-2);
        let day = ('0' + date.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
    }
    return null;
};

export const formatDisplayDate = (dateVal) => {
    if (dateVal) {
        const jsDate = DateTime.fromJSDate(dateVal);
        return !jsDate.invalid ? jsDate.toFormat('dd-MM-yyyy') : DateTime.fromFormat(dateVal, 'dd/MM/yyyy').toFormat('dd-MM-yyyy');
    }
    return null;
};

export const formatMetricDisplayDate = (dateVal) => {
    if (dateVal) {
        return DateTime.fromFormat(dateVal, 'yyyy-MM-dd HH:mm:ss').toFormat('dd-MM-yyyy');
    }
    return null;
};

export const formatMetricRequestDate = (dateVal) => {
    if (dateVal) {
        const jsDate = DateTime.fromJSDate(dateVal);
        return !jsDate?.invalid ? jsDate.toFormat('yyyy-MM-dd') : DateTime.fromFormat(dateVal, 'dd-MM-yyyy').toFormat('yyyy-MM-dd');
    }
    return null;
};

export const formatISODateToJSDate = (dateVal) => {
    return dateVal ? DateTime.fromISO(dateVal).toJSDate() : null;
};

export const checkDateFormat = (stringVal) => {
    const dateRegex = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{1,3})?Z)?$/;
    return dateRegex.test(stringVal);
};
